(function () {

  
  function removeActiveClassFromCards() {
    // 1. Select all elements that have BOTH classes.
    // The selector '.class1.class2' finds elements with both class1 and class2.
    const activeCards = document.querySelectorAll('.card_atc--content.active');

    console.log(`Found ${activeCards.length} element(s) to change.`);

    // 2. Loop through the found elements (if any) and remove the 'active' class.
    activeCards.forEach(card => {
      card.classList.remove('active');
      console.log('Removed "active" class from:', card);
    });

    if (activeCards.length === 0) {
      console.log("No active cards found to update. (Try refreshing the page and clicking again).");
    }
  }

  

  class CardProduct extends HTMLElement {
  
    constructor() {
      // Always call super first in constructor
      super();

      const quickAtc = this.querySelector('.card_quick-atc');
      
      const quickAtcCloseButton = this.querySelector('.card_atc--close');
      quickAtc.addEventListener('click', function(e) {
        e.preventDefault();
        console.log('cdebug quickatc', quickAtc);
        if(quickAtc.dataset.preorder) {
          document.location.href = quickAtc.dataset.url
        }
        removeActiveClassFromCards();
        quickAtc.closest('.card').querySelector('.card_atc--content').classList.add('active');

      })

      quickAtcCloseButton.addEventListener('click', function(e) {
        e.preventDefault();
        
        quickAtcCloseButton.closest('.card').querySelector('.card_atc--content').classList.remove('active');

      })
    }
  }
  
  customElements.define("card-product", CardProduct);
})();